// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

import axios from 'axios'
import http from './utils/http'

import Vuex from 'vuex'
import store from './store/store'
Vue.use(Vuex)
Vue.prototype.$axios = http

import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

import print from './utils/print.js'
Vue.use(print);

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	ViewUI.LoadingBar.start();
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title
	}
	// next();
	if (store.getters.token) {
		if (to.path === '/login') {
			next()
		} else {
			if (store.getters.addRouters.length === 0) {
				store.dispatch('GenerateRoutes', { }).then(() => {
					next({ ...to, replace: true })
				})
			} else {
				next()
			}
		}
	} else {
		if (to.path == '/login') {
			next()
		} else {
			next('/login')
		}
	}
});

router.afterEach(route => {
	ViewUI.LoadingBar.finish();
});

/** GLOBAL START **/
// global.GLOBAL_URL = "http://www.zccms.com/"; //线下
global.GLOBAL_URL = "https://aapi.ahsjsd.com/"; //线上
// global.GLOBAL_URL = "https://zapi.ahsjsd.com/"; //线上测试
// global.GLOBAL_URL = "https://hapi.ahsjsd.com/"; //线上测试

//上传通用
global.GLOBAL_UPLOAD_URL = global.GLOBAL_URL+"admin/upload/uploadImage";
/** GLOBAL END **/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,store, Vuex, axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js